var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyCashBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.327 9H8.08705C6.38212 9 5 10.3994 5 12.1256V30.8795C5 32.6057 6.38212 34.0051 8.08705 34.0051H34.327C36.0319 34.0051 37.4141 32.6057 37.4141 30.8795V12.1256C37.4141 10.3994 36.0319 9 34.327 9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6696 25.6703C24.227 25.6703 26.3002 23.5972 26.3002 21.0398C26.3002 18.4824 24.227 16.4092 21.6696 16.4092C19.1122 16.4092 17.0391 18.4824 17.0391 21.0398C17.0391 23.5972 19.1122 25.6703 21.6696 25.6703Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2617 41.4142H42.6009C43.436 41.4142 44.2369 41.0889 44.8274 40.51C45.4179 39.931 45.7497 39.1458 45.7497 38.3271V22.8918",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCashBill);
export default __webpack_public_path__ + "static/media/money-cash-bill.c08fd01d8514793b2757c972d26d82e9.svg";
export { ForwardRef as ReactComponent };